export function pushUserReady(userInfo) {
  if (!userInfo?.id) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'user_ready',
    user_id: userInfo.id,
    area_of_interest: userInfo.areaOfInterest ?? null,
    email: userInfo.email ?? null
  });
}
